// Services grid section scaffold (collection layout for services).
import ServiceCard from "./ServiceCard";

export default function ServicesGrid({ services, orderText }) {
  return (
    <div className="services-content">
      <div className="services-cards">
        {services.map((service, idx) => (
          <ServiceCard
            key={idx}
            index={idx}
            title={service.title}
            desc={service.desc}
            details={service.details}
            orderText={orderText}
          />
        ))}
      </div>
    </div>
  );
}

